import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Principal} from '@app/core';
import {AngularFireMessaging} from '@angular/fire/compat/messaging';
import {LanguageService} from '@core/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));

  currentLang = 'vi';

  constructor(
    private breakpointObserver: BreakpointObserver,
    public principal: Principal,
    private afMessaging: AngularFireMessaging,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {
    const savedLang = localStorage.getItem('app_lang');
    this.currentLang = savedLang || this.translate.currentLang || 'vi';
    this.translate.setDefaultLang('vi');
    // Use the language service to ensure subscribers are notified when translations finish loading
    this.translate.use(this.currentLang);
    localStorage.setItem('app_lang', this.currentLang);
  }

  ngOnInit(): void {
    // Subscribe to language changes so components can react if needed
    this.languageService.lang$.subscribe((lang) => {
      this.currentLang = lang;
      // Update document title if the app sets it via translate.instant elsewhere
      try {
        const titleKey = 'global.title';
        const t = this.translate.instant(titleKey);
        if (t) {
          document.title = t;
        }
      } catch (e) {}
    });
  }

  switchLang(lang: string) {
    this.languageService.changeLang(lang);
  }
}
